import script from "./Departures.vue?vue&type=script&setup=true&lang=js"
export * from "./Departures.vue?vue&type=script&setup=true&lang=js"

import "./Departures.vue?vue&type=style&index=0&id=6fbc5da2&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbc5da2"]])

export default __exports__